let lastUserEvent = null;

if (typeof window !== "undefined") {
  document.addEventListener("click", (e) => {
    lastUserEvent = {
      type: "click",
      time: new Date().toISOString(),
      target: e.target?.outerHTML?.slice(0, 300),
    };
  });

  document.addEventListener("keydown", (e) => {
    lastUserEvent = {
      type: "keydown",
      time: new Date().toISOString(),
      key: e.key,
      target: e.target?.outerHTML?.slice(0, 300),
    };
  });
}

export const getLastUserEvent = () => lastUserEvent;
